/**
 * NEW_PLANS_FLAG
 *
 * Centralized feature flag for the new plans UI (PlansCards, UpgradeFeatureModal,
 * UpgradeWindow, UpgradePlanSuccessModal, new account-creation plan/payment pages).
 *
 * Gate: both `beta_tester` AND `beta_tester_internal` user flags must be true.
 *
 * To launch to all users:
 *   1. Search for "isNewPlans" / "isNewPlansEnabled" across the codebase
 *   2. Remove all conditional branches, keeping only the "new plans" code
 *   3. Delete this file
 *   4. Remove legacy account-creation pages (src/views/Auth/AccountCreation/legacy/)
 */

import { computed } from 'vue'
import { useUserStore } from '@/stores/UserStore'

// On localhost we treat every gated feature as enabled, so devs can work on
// flagged surfaces (Orders, the upgraded Sale Pick List, etc.) without the BE
// flag set on their account. Real environments still honour the flag.
export const isLocalhost = () =>
  typeof window !== 'undefined' && window.location?.hostname === 'localhost'

export const useNewPlans = () => {
  const userStore = useUserStore()
  return computed(() => !!(userStore.flags?.beta_tester && userStore.flags?.beta_tester_internal))
}

export const isNewPlansEnabled = () => {
  const userStore = useUserStore()
  return !!(userStore.flags?.beta_tester && userStore.flags?.beta_tester_internal)
}

/*
 * Launched, flags removed (2026-08-24):
 *   `bulk-delist` — Bulk End / Relist. Now on for everyone.
 *   `csv-import`  — Inventory CSV import. Now on for everyone; the PLAN
 *                   entitlement (`csv-inventory-import`) still gates it inside
 *                   `InventoryCsvImportModal` and is unrelated to this file.
 */
